var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20,
    r: 20,
    fill: "#FBEDE1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4998 16V20M20.4998 24H20.5098M18.7898 10.86L10.3198 25C10.1451 25.3024 10.0527 25.6453 10.0518 25.9945C10.0508 26.3437 10.1413 26.6871 10.3142 26.9905C10.4871 27.2939 10.7365 27.5467 11.0375 27.7238C11.3385 27.9009 11.6806 27.9961 12.0298 28H28.9698C29.319 27.9961 29.6611 27.9009 29.9621 27.7238C30.2631 27.5467 30.5124 27.2939 30.6854 26.9905C30.8583 26.6871 30.9488 26.3437 30.9478 25.9945C30.9468 25.6453 30.8544 25.3024 30.6798 25L22.2098 10.86C22.0315 10.5661 21.7805 10.3231 21.481 10.1544C21.1814 9.98581 20.8435 9.89722 20.4998 9.89722C20.156 9.89722 19.8181 9.98581 19.5186 10.1544C19.2191 10.3231 18.968 10.5661 18.7898 10.86Z",
    stroke: "#DC6803",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert-icon.da2d83c2f2048b81741d9e051260af2d.svg";
export { ForwardRef as ReactComponent };